/** Homère Classic yes/no flag code: `'O'` (oui/yes) or `'N'` (non/no). */
export type YesNoCode = 'O' | 'N';

export function boolCode(v: unknown): YesNoCode | undefined {
  if (v === true  || v === 1 || v === 'O') return 'O';
  if (v === false || v === 0 || v === 'N') return 'N';
  return undefined;
}

/**
 * Decode a Homère Classic O/N flag to a boolean. `'O'` (or `1`/`true`) → `true`;
 * everything else (`'N'`, `null`, `undefined`, unknown) → `false`. Use this
 * anywhere a raw O/N flag needs a boolean, rather than reimplementing `=== 'O'`.
 */
export const isYesCode = (v: unknown): boolean => boolCode(v) === 'O';
